export class Brand {
  id: string;
  name: string;
  photo: string;
}
